<style lang="css" scoped>
.layout-select {
  width: 100%;
  height: calc(33.5px + 41px);
  /* background: gray; */
}
.layout-upload {
  width: 100%;
  height: 35%;
  /* background: yellow; */
}
.layout-action {
  width: 100%;
  height: 57px;
  /* background: purple; */
  /* opacity: 0.5; */
}
.layout-table {
  width: 100%;
  height: 50%;
  /* background: pink; */
}
.layout-table-selected {
  height: 100%;
  /* background: pink; */
}

.layoutContent {
  height: 100% !important;
  width: 100% !important;
}
</style>
<template>
  <div class="main-layout overflow-y-auto">
    <!-- NOTE SELECT FILE -->
    <div class="layout-upload">
      <div
        class="layoutContent"
      >
        <u-upload-dragdrop
          v-model="files"
          accept="image/png, image/jpeg ,.dcm,.jpg"
          @input="CreateDataTable"
        ></u-upload-dragdrop>
      </div>
    </div>

    <!-- NOTE ACTION BUTTON & VIEW FILE TO UPLOAD -->
  <div class="d-flex flex-wrap green align-center my-2">
      <div>
      <v-img
        style="width: 24px; height: 24px; margin-right: 5px"
        src="@/assets/images/xraypage/detail-upload-title.png"
      ></v-img>
    </div>
    <div class="pink detail-upload-title">
      ตรวจสอบรายการอัปโหลด
    </div>
  </div>
    <div
      :class="[
        'layoyt-job',
        items.length ? 'layout-table-selected' : 'layout-table',
      ]"
    >
      <div class="layout-content" style="height: 350px;" title="3.ตรวจวิเคราะห์โรค">
       <div style="height: calc(100% - 33.5px);
  overflow: scroll;">
         <u-table
          :headers="headers"
          :items="items"
          :mobileBreakpoint="900"
          :showSelect="false"
          itemKey="id"
          :loading="loading"
          :pagination="pagination"
          :offsetHeight="items.length ? 0 : -48"
        >
          <template v-slot:header>
            <v-row justify="start" align="center" dense style="height: 100%">
              <v-col cols="6" sm="3" md="2">
                <v-btn
                  :disabled="files.length <= 0"
                  color="error"
                  block
                  @click="Reset"
                  >ลบทั้งหมด</v-btn
                >
              </v-col>
              <v-col cols="6" sm="3" md="2">
                <v-btn
                  :disabled="
                    files.length <= 0
                  "
                  color="primary"
                  block
                  @click="upload"
                    >อัปโหลดไฟล์</v-btn
                >
              </v-col>
            </v-row>
          </template>
          <!--  NOTE Status Upload -->
          <template v-slot:[`item.index`]="{ item }">
            {{ items.indexOf(item) + 1 }}
          </template>

          <!-- NOTE Progress Upload -->
          <template v-slot:[`item.uploadprogress`]="{ item }">
            <v-progress-linear
              striped
              class="rounded-pill"
              :value="item.progress"
              height="15"
            >
              <strong style="color: #fff">{{ item.progress }}%</strong>
            </v-progress-linear>
          </template>

          <!--  NOTE Status Upload -->
          <template v-slot:[`item.status`]="{ item }">
            <v-icon v-if="item.progress >= 100" color="success">
              mdi-checkbox-marked
            </v-icon>
          </template>

          <!-- NOTE Acrtion Upload -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="!(item.progress == 0)"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  fab
                  x-small
                  :dark="item.uploadprogress == 0"
                  color="error"
                  @click="deleteItem(item)"
                >
                  <v-icon>mdi-delete-forever</v-icon>
                </v-btn>
              </template>
              <span>ลบ</span>
            </v-tooltip>
          </template>
        </u-table>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
// import layoutContent from '@/components/Uploads/layoutContent.vue'
import { mapMutations } from 'vuex'
import { uuid } from 'vue-uuid'
export default {
  components: {
    // layoutContent
  },
  props: {
    hospital_id: {
      type: String
    },
    type: {
      type: String,
      default: 'single'
    },
    seriesId: {
      type: String,
      default: uuid.v4()
    }
  },
  data () {
    return {
      files: FileList,
      tmpFiles: FileList,
      diagnosisList: [],
      // type: 'single',
      series_id: '',
      allname: [],
      statusUpload: true,
      headers: [
        {
          text: 'ลำดับที่',
          align: 'center',
          value: 'index',
          sortable: false,
          width: '10%'
        },
        {
          text: 'ชื่อไฟล์',
          value: 'name',
          align: 'start',
          sortable: false,
          width: '40%'
        },
        {
          text: 'ความคืบหน้า',
          value: 'uploadprogress',
          align: 'center',
          sortable: false,
          width: '30%'
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'จัดการ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '10%'
        }
      ],
      items: [
        // {
        //   index: 0,
        //   size: '',
        //   fileNae: '',
        //   proress: 0
        // }
      ],
      tmpItems: [],

      // switch: [],
      // wait: false,
      // selected: [],
      // switch1: false,
      // scrollInvoked: 0,

      loading: false,
      pagination: {
        total: 0,
        page: 1,
        row: 10
      }
      // files: [],
      // isSelecting: false,
    }
  },
  created () {
    this.init()

    // NOTE สำหรับการรับ EventBus จาก Function Background Upload
    // this.$EventBus.$on('upload-progress', (val) => {
    //   this.items
    //     .filter((x) => x.id === val.id)
    //     .forEach((x) => {
    //       x.progress = val.progress
    //     })
    //   if (this.items.every((x) => x.progress === 100)) {
    //     this.$swal({
    //       allowEnterKey: false,
    //       title: 'สำเร็จ',
    //       text: 'อัปโหลดไฟล์ทั้งหมดเสร็จสิ้น',
    //       icon: 'success',
    //       showConfirmButton: false,
    //       showCancelButton: false,
    //       timer: 3000
    //     })
    //     setTimeout(() => {
    //       this.$emit('toHistory')
    //     }, 3000)
    //   }
    // })
  },
  methods: {
    ...mapMutations(['addUploadBackground']),
    async CreateDataTable (val) {
      let tmp = val
      if (!this.statusUpload) {
        // TODO Clear Old file
        tmp = await tmp.filter((x) => {
          const i = this.tmpFiles.filter((y) => {
            // TODO เมื่อมีไฟล์อยู่แล้ว
            return y.id === x.id
          })
          // TODO หากว่ามี file return false
          return !(i.length > 0)
        })

        // TODO Reset State Upload
        this.files = tmp
        this.statusUpload = true
      }

      this.items = Object.assign([])
      // FIX UKRIT สำหรับส่วนจัดการ Item สำหรับทำ Progress
      if (this.type === 'single') {
        for (const item of tmp) {
          this.items.push({
            id: item.id,
            size: item.size,
            name: item.name,
            progress: 0
          })
        }
      } else if (this.type === 'series') {
        this.items.push({
          id: 0,
          name: `Upload ${this.files.length} file`,
          progress: 0,
          size: 0
        })
      }

      // console.log(this.items)
    },

    async init () {
      // NOTE Reset All Current State
      this.Reset()

      const payload = {
        hospital_id: this.hospital_id
      }

      const res = await this.getHospitalPackageForUpload(payload)
      // NOTE SUCCESS
      if (res.status) {
        this.allname = res.data.map((i) => {
          return {
            name: i.name,
            service_id: i.service_id
          }
        })
        this.diagnosisList = this.allname
      } else {
        // NOTE ERROR
        console.log(res)
      }
    },

    async upload () {
      this.statusUpload = false
      // this.seriesId = ''
      if (this.type === 'series') {
        this.CreateMultiJobForUploadV2(
          this.hospital_id,
          this.diagnosisList,
          this.files,
          this.type,
          this.series_id
        )
      } else {
        this.CreateMultiJobForUpload(
          this.hospital_id,
          this.diagnosisList,
          this.files,
          this.type,
          this.series_id
        )
      }
      this.tmpItems = this.items
      this.tmpFiles = this.files
      this.addUploadBackground(this.tmpItems)
    },

    deleteItem (item) {
      this.files = this.files.filter((x) => x.id !== item.id)
      this.items = this.items.filter((x) => x.id !== item.id)
    },

    Reset () {
      this.items = Object.assign([])
      this.files = Object.assign([])
      this.statusUpload = true
      // this.allname = []
      // this.diagnosisList = []

      // this.selected = []
      // this.switch1 = false
      // this.wait = false
    }
  },
  watch: {
    switch1 (newValue) {
      if (newValue) {
        this.selected = this.allname.map((e) => e.service_id)
      } else {
        this.selected = []
      }
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    files (x) {
      this.pagination.total = this.items.length
    }
  }
}
</script>

<style lang="css" scoped>
.text-warning {
  position: absolute;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-layout {
  height: 100%;
  scrollbar-width: none !important;
  /* background-color: pink; */
}
/* // TODO สำหรับจัดการ Content ของเพจ */
.title-header-text {
  color: var(--v-primary-base);
  font-weight: 300;
  font-size: 20px;
  margin-bottom: 20px;
  margin-top: 40px;
}
.title-header-line {
  color: var(--v-primary-base);
  margin-bottom: 40px;
}
.text-title {
  color: var(--v-tprimary-base);
  font-size: 16px;
}
.first-letter {
  font-size: 1rem;
  color: var(--v-primary-base);
}

.first-letter1 {
  color: var(--v-tprimary-base);
}
.grid-container {
  display: grid;
  grid-template-columns: 210px 1fr;
}
.grid-container1 {
  display: grid;
  grid: auto;
  /* padding-left: 10px; */
}
.grid1-container {
  display: grid;
  grid: auto auto auto auto auto auto / auto auto auto auto auto auto;
}
.grid2-container {
  display: grid;
  grid: auto auto auto / auto auto auto;
}
.layout-content {
  /* height: calc(100% - 300px); */
  height: 300px;
  padding: 0;
  margin: 0;
  /* background: red; */
}
.layout-content .upload {
  /* // background: green; */
  height: calc(100% - 100px);
}
.bottom-upload {
  color: white;
  margin-right: 20px;
}
.layout {
  /* background: yellow; */
  height: 100%;
  width: 100%;
  /* padding: 16px; */
  border-style: dashed;
  border-color: var(--v-primary-base);
  border-width: 2px;
  border-radius: 5px;
}

.dragdrop .dragging {
  background: #dddddd;
}

.dragdrop {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: green; */
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
}
.dragdrop .drop-items {
  /* // background: red; */
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.dragdrop .content {
  position: absolute;
  /* width: 10%; */
  /* height: 10%; */
  /* background: blue; */
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content .message {
  display: flex;
  justify-content: center;
  align-items: center;
  /* // color: var(--v-primary-base); */
}
.layout-content{
  background: yellow;
  width: 100%;
  height: 100%;
}
.detail-upload-title{
  font-weight: 700;
  font-size: 20px;
  color: #20409C;
}
>>> .v-input--switch .v-input__control .v-input__slot .v-label {
  color: var(--v-primary-base);
}
>>> .v-input .v-label {
  color: var(--v-tprimary-base);
}

>>> .mdi-checkbox-outline::before {
  color: var(--v-disable-base);
}
>>> .v-input--is-label-active .v-label {
  color: var(--v-disable-base);
}
@media only screen and (max-width: 600px) {
  .grid2-container {
    grid: auto / auto;
    padding-left: 10px;
  }
}
</style>
